<div class="fui-layout-container">
  <fui-layout-header [breadcrumbs]="breadcrumbs" headingText="sphere.workspaces.workspaces" description="sphere.workspaces.header">
    <div class="fui-nav-pills m-t-30">
      <ul>
        <li>
          <button [class.active]="displayedSection == 'workspaces'" (click)="switchSection('workspaces')" (keyup.enter)="switchSection('workspaces')" (keyup.space)="switchSection('workspaces')">
            {{ "sphere.workspaces.my_workspaces" | translate }}
          </button>
        </li>

        <li>
          <button [class.active]="displayedSection == 'collabs'" (click)="switchSection('collabs')" (keyup.enter)="switchSection('collabs')" (keyup.space)="switchSection('collabs')">
            {{ "sphere.workspaces.my_collabs" | translate }}
          </button>
        </li>
        <li>
          <button [class.active]="displayedSection == 'invitations'" (click)="switchSection('invitations')" (keyup.enter)="switchSection('invitations')" (keyup.space)="switchSection('invitations')">
            {{ "sphere.workspaces.my_invitations" | translate }}
            @if (invites?.length) {
              <span class="badge">{{ invites?.length }}</span>
            }
          </button>
        </li>
      </ul>
      @if (user.active_subscription) {
        <button class="fui-action-btn m-y-5" (click)="add()">
          <fa-icon icon="plus"></fa-icon>
          {{ "sphere.workspaces.create_workspace" | translate }}
        </button>
      }
    </div>
  </fui-layout-header>
  <hr />
  <div class="fui-layout-pad-content">
    <fui-content-filter
      #fuiContentFilter
      [activeQuery]="filterQuery"
      [showSidebarToggle]="false"
      [showSearchInput]="false"
      [resultsCount]="displayedSection == 'workspaces' ? workspaces?.length : collabs?.length"
      (sortChanged)="sortWorkspaces()"
    ></fui-content-filter>
  </div>
  <hr />
  @if (displayedSection == "workspaces" || displayedSection == "collabs") {
    @if (loading) {
      @if (loading) {
        <myp-skeleton-loader type="product-tile" height="250px" [number]="6" class="grid-container pad-10"></myp-skeleton-loader>
      }
    }
    @if (!workspaces?.length && !collabs?.length && !loading) {
      <div class="fui-layout-pad-content">
        <div class="m-y-50">
          <fui-heading [text]="'sphere.workspaces.empty_state_title' | translate" fontSize="f7" level="2"></fui-heading>
          <p class="m-t-20">
            {{ "newdash.workspaces_slug" | translate }}
          </p>
          <button class="btn btn-secondary" (click)="workspacesVideo()">{{ "general.learn_more" | translate }}</button>
          &nbsp;&nbsp;&nbsp;
          @if (!user.active_subscription) {
            <button class="btn btn-primary" (click)="add()">{{ "onboarding.join_now" | translate }}</button>
          }
          @if (user.active_subscription) {
            <button class="btn btn-primary" (click)="add()">{{ "sphere.workspaces.create_your_first_workspace" | translate }}</button>
          }
        </div>
      </div>
    }
    @if ((workspaces?.length || collabs?.length) && appService.prefersGrid) {
      <div class="fui-layout-edge-content">
        <ul class="grid-container pad-10 m-t-30">
          @for (workspace of displayedSection == "workspaces" ? workspaces : collabs; track workspace) {
            <li
              [ngStyle]="{ background: workspace.gradient ? 'linear-gradient(180deg, ' + workspace.gradient.color1 + ' 0%, ' + workspace.gradient.color2 + ' 100%)' : '' }"
              class="workspace-grid-item"
              tabindex="0"
              (click)="goToWorkspace(workspace.id)"
              (keyup.enter)="goToWorkspace(workspace.id)"
              (keyup.space)="goToWorkspace(workspace.id)"
            >
              <div class="position-relative h-full" role="group" aria-label="support option">
                @if (workspace.image) {
                  <img [src]="workspace.image" />
                }
                <div class="d-flex flex-column justify-content-end h-full position-relative">
                  <div class="name">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="detail-container">
                        <fui-heading [text]="workspace.name" level="2" fontSize="f6" extraClasses="bold creator-title t-20"></fui-heading>
                        <span class="description">{{ workspace.description }}</span>
                        <span class="created">{{ workspace.date_created | date: "MMMM d, yyyy" }}</span>
                      </div>
                      <fa-icon icon="chevron-right"></fa-icon>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          }
        </ul>
      </div>
    }
    @if ((workspaces?.length || collabs?.length) && !appService.prefersGrid) {
      <div class="fui-layout-pad-content">
        @if (!appService.prefersGrid) {
          <div class="list-container pad-10 m-t-30">
            @for (workspace of displayedSection == "workspaces" ? workspaces : collabs; track workspace) {
              <myp-list-item
                [item]="workspace"
                [title]="workspace.name"
                [imageRound]="false"
                (itemClicked)="goToWorkspace(workspace.id)"
                [subData]="[workspace.description?.length > 200 ? workspace.description.substring(0, 200) + '...' : workspace.description, workspace.date_created | date: 'MMMM d, yyyy']"
                [photo]="workspace.image || './assets/icons/workspace.png'"
              ></myp-list-item>
            }
          </div>
        }
      </div>
    }
  }

  @if (displayedSection == "invitations") {
    <div class="fui-layout-pad-content">
      @if (!invites?.length) {
        <div class="m-y-50">
          <fui-heading [text]="'sphere.workspaces.collaboration_invitations' | translate" fontSize="f7" level="2"></fui-heading>
          <br />
          {{ "sphere.workspaces.no_pending_invitations_message" | translate }}
        </div>
      }
      @if (invites?.length) {
        <div class="m-t-30">
          <myp-collaboration-invite-notice></myp-collaboration-invite-notice>
        </div>
      }
    </div>
  }

  <div class="m-t-100 p-b-50">
    <fui-footer></fui-footer>
  </div>
</div>
